import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import config from '../../../config';
import { AuthContext } from '../../../contexts/authContext';
import { EditIcon, TrashIcon, AddIcon, CachedIcon } from '../../../assets/icons/icons';
import { IconButton } from '@mui/material';
import ManagePanelDialog from './ManagePanelDialog';
import DeletePanelDialog from './DeletePanelDialog';
import './Panels.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import {
	DataGridPremium
} from '@mui/x-data-grid-premium';
import { LicenseInfo } from '@mui/x-license';
import useNotification from '../../../hooks/useNotification';

LicenseInfo.setLicenseKey(config.MUI_DATA_GRID_PREMIUM_LICENSE);

const theme = createTheme(
    {
        palette: {
            primary: { main: '#1976d2' },
        },
    },
    itIT,
);

const PanelCell = (params) => {
    return(
        <div>
            {params?.value}
        </div>
    )
}

const ActionCell = (params, openDialog, openDeleteDialog) => {
    return(
        <div>
            <IconButton onClick={() => openDialog('mod')} size='small' >
                <EditIcon addClass='pointer'></EditIcon>
            </IconButton>
            <IconButton onClick={openDeleteDialog} size='small'>
                <TrashIcon addClass="pointer" ></TrashIcon>
            </IconButton>
        </div>
    )
}

const ActionHeaderCell = (params, openDialog, getPanels, getGroups, getBanners) => {
    return(
        <div className="centered-cell" >
            <IconButton title='Ricarica dati' onClick={() => {
                getPanels();
                getGroups();
                getBanners()
            }} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
            <IconButton onClick={() => openDialog('ins')} size='small' title='Inserisci Impianto' >
                <AddIcon addClass='pointer'/>
            </IconButton>
        </div>
    )
}

function Panels(props) {
    const auth = useContext(AuthContext);
    const { panels, setPanels, groups, setGroups, banners, setBanners } = useContext(AppAuthGlobalVariables);
    const { notificationError } = useNotification();

    const [loading, setLoading] = useState(true);
    const [panelsLoading, setPanelsLoading] = useState(true);

    const [groupsAutocomplete, setGroupsAutocomplete] = useState([]);
    const [bannersAutocomplete, setBannersAutocomplete] = useState([]);

    const [openManagePanelDialog, setOpenManagePanelDialog] = useState(false);
    const [openDeletePanelDialog, setOpenDeletePanelDialog] = useState(false);
    const [lastCellData, setLastCellData] = useState(null);

    const columns = [
        {field: 'ACTION', headerClassName: 'header-cell action-cell', headerName: '', type: 'string', width: 100, align: 'center', headerAlign: 'center', disableColumnMenu: true, sortable: false, disableExport: true, renderHeader: (params) => ActionHeaderCell(params, handleOpenManagePanelDialog, getPanels, getGroups, getBanners), renderCell: (params) => ActionCell(params, handleOpenManagePanelDialog, handleOpenDeletePanelDialog)},
        {field: 'idEntita', headerClassName: 'header-cell id', headerName: 'Id Impianto', type: 'string', width: 150, align: 'right', headerAlign: 'right', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.S},
        {field: 'nome', headerClassName: 'header-cell nome', headerName: 'Nome Fermata', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.S},
        {field: 'comune', headerClassName: 'header-cell comune', headerName: 'Comune', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.S},
        {field: 'municipio', headerClassName: 'header-cell municipio', headerName: 'Municipio', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.S},
        {field: 'toponomia', headerClassName: 'header-cell toponomia', headerName: 'Toponomia', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.S},
        {field: 'address', headerClassName: 'header-cell address', headerName: 'Indirizzo', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.S},        
        {field: 'idFermata', headerClassName: 'header-cell id-fermata', headerName: 'Id Fermata', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.S},
        {field: 'lat', headerClassName: 'header-cell lat', headerName: 'Latitudine', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.S},
        {field: 'lon', headerClassName: 'header-cell lon', headerName: 'Longitudine', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.S},
        //{field: 'groupList', headerClassName: 'header-cell groupList', headerName: 'Gruppi', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.SS?.join(', ') || ''},
        //{field: 'bannerList', headerClassName: 'header-cell bannerList', headerName: 'Banners', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.SS?.join(', ') || ''},
        {field: 'status', headerClassName: 'header-cell status', headerName: 'Status', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.S === 'G' ? 'Guasto' : params?.S === 'Y' ? 'Attivo' : params?.S === 'N' ? 'Non Attivo' : "Non in Servizio"},
        {field: 'tipologia', headerClassName: 'header-cell tipologia', headerName: 'Tipologia', type: 'string', flex: 1, align: 'left', headerAlign: 'left', renderCell: (params) => PanelCell(params), valueGetter: (params) => params?.S === 'T' ? 'Totem' : 'Palina'},
    ]

    useEffect(() => {
        if(!panels.length || !groups.length || !banners.length){
            getPanels();
            getGroups();
            getBanners();
        }else{
            convertGroupsForAutocomplete(groups);
            convertBannersForAutocomplete(banners);
            setPanelsLoading(false);
            setLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(!loading){
            getPanels();
            getGroups();
            getBanners();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.city])

    const getPanels = async() => {
        try {
            setLoading(true);
            setPanelsLoading(true);

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-panels',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            setPanels(response.data.dataToReturn);
            setPanelsLoading(false);
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setPanelsLoading(false);
            setLoading(false);
        }
    }

    const getGroups = async() => {
        try {
            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-groups',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            const allGroups = response.data.dataToReturn;
            
            setGroups(allGroups);
            convertGroupsForAutocomplete(allGroups);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const getBanners = async() => {
        try {
            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-banners',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            const allBanners = response.data.dataToReturn;
            
            setBanners(allBanners);
            convertBannersForAutocomplete(allBanners);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const convertGroupsForAutocomplete = (list) => {
        let copyList = [...list] || [];
        for (let index = 0; index < copyList.length; index++) {
            let element = copyList[index];
            
            let newElement = {
                id: element?.idEntita?.S,
                label: element?.descrizione?.S || ''
            };
            copyList[index] = newElement;
        }

        setGroupsAutocomplete(copyList);
    }

    const convertBannersForAutocomplete = (list) => {
        let copyList = [...list] || [];
        for (let index = 0; index < copyList.length; index++) {
            let element = copyList[index];
            
            let newElement = {
                id: element?.idEntita?.S,
                label: element?.descrizione?.S || ''
            };
            copyList[index] = newElement;
        }

        setBannersAutocomplete(copyList);
    }

    const handleOpenManagePanelDialog = (action) => {
        setOpenManagePanelDialog(action)
    }
    const handleCloseManagePanelDialog = () => {
        setOpenManagePanelDialog(false);
    }

    const handleOpenDeletePanelDialog = () => {
        setOpenDeletePanelDialog(true);
    }   
    const handleCloseDeletePanelDialog = () => {
        setOpenDeletePanelDialog(false);
    }

    return (
        <div className='component-container panels'>
            <div className='component-card'>
                <ThemeProvider theme={theme}>
                    <DataGridPremium
                        rows={panels}
                        columns={columns}
                        className="panels-table"
                        loading={panelsLoading}
                        rowHeight={30}
                        onCellClick={(params) => setLastCellData(params.row)}
                        getRowId={(row) => row.idEntita.S}
                        disableAggregation
                        disableRowGrouping
                        disableDensitySelector
                        disablePivoting
                        showToolbar
                        slotProps={{
                            toolbar: {
                                printOptions: { disableToolbarButton: true },
                                csvOptions: { fileName: `impianti_${props.city}_${new Date().getFullYear()}${(new Date().getMonth()+1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}`},
                                excelOptions: { fileName: `impianti_${props.city}_${new Date().getFullYear()}${(new Date().getMonth()+1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}`}
                            }
                        }}
                    />
                </ThemeProvider>
            </div>
            <ManagePanelDialog {...{
                openManagePanelDialog,
                handleCloseManagePanelDialog,
                lastCellData,
                getPanels,
                //pois: poisAutocomplete,
                groups: groupsAutocomplete,
                banners: bannersAutocomplete,
                city: props.city,
                logOut: props.logOut
            }}/>
            <DeletePanelDialog {...{
                openDeletePanelDialog,
                handleCloseDeletePanelDialog,
                lastCellData,
                getPanels
            }}/>
        </div>
    )
}

export default Panels